"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.repeatScheduleTask = exports.scheduleAtFixedRate = void 0;
/*
 * @param {number} interval - execute task when UTC timestamp is divisible by the given interval
 *                            e.g. scheduleAtFixedRate(() => {},  24 * 60 * 60 * 1000) triggers the
 *                            task once a day at 00:00 UTC
 *                            (but no tasks will be executed concurrently: if a previous task is
 *                            still ongoing when the next task should, the new task is silently skipped)
 */
const scheduleAtFixedRate = (task, interval) => {
    return (0, exports.repeatScheduleTask)((doneCb) => {
        const now = Date.now();
        const next = now - (now % interval) + interval;
        return setTimeout(async () => {
            await task(next);
            doneCb();
        }, (next - now));
    });
};
exports.scheduleAtFixedRate = scheduleAtFixedRate;
/** @internal */
const repeatScheduleTask = (scheduleNextTask) => {
    let timer;
    let stopRequested = false;
    const scheduleNext = () => {
        if (!stopRequested) {
            timer = scheduleNextTask(scheduleNext);
        }
    };
    scheduleNext();
    return {
        stop: () => {
            stopRequested = true;
            clearTimeout(timer);
        }
    };
};
exports.repeatScheduleTask = repeatScheduleTask;
//# sourceMappingURL=scheduleAtFixedRate.js.map